import { fetchExportDataAction } from "@/api/actions/clipShares";

import { queryOptions } from "@tanstack/react-query";

export const clipSharesForCsvShareOptions = (clipShare: number) => {
  return queryOptions({
    queryKey: ["clipShares", `${clipShare}`] as const,
    queryFn: async () => await fetchExportDataAction(clipShare),
  });
};

export const myClipSharesInBookmarksOptions = () => {
  return queryOptions({
    queryKey: ["myClipSharesInBookmarks"] as const,
    queryFn: async (): Promise<Map<string, Map<string, number[]>>> => {
      const response = await fetch("/api/clipShares/my_clips_in_bookmarks");
      if (!response.ok) {
        throw new Error("Failed to fetch my clips in bookmarks");
      }
      const responseRecord: Record<
        string,
        Record<string, number[]>
      > = await response.json();
      
      // Convert back to Map structure
      return new Map(
        Object.entries(responseRecord).map(([meetingId, transcriptRecord]) => [
          meetingId,
          new Map(Object.entries(transcriptRecord)),
        ]),
      );
    },
  });
};